import { render, staticRenderFns } from "./HistoricoOcorrencia.vue?vue&type=template&id=622002a1"
import script from "./HistoricoOcorrencia.vue?vue&type=script&lang=js"
export * from "./HistoricoOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./HistoricoOcorrencia.vue?vue&type=style&index=0&id=622002a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports